module.exports = __webpack_public_path__ + "img/5.1fea8b2c.jpg";